
import React, { useEffect, useState, useMemo } from 'react';
import { Switch, Input, MainModal, ExpandableText, Form, CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, Button, Tag, Select, Row, Col, Modal, Typography, message, ProTableOt, useProTableOt, Tabs, Spin, Skeleton, Popconfirm, ImportButton } from '../ui/ot'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { useRef } from 'react';
import styled from "styled-components"
import { useStaffStatisticsGender } from './controllers/staff_statistics_gender_controller'
import { useStaffStatisticsDepartment } from './controllers/staff_statistics_department_controller'
import { useStaffStatisticsRole } from './controllers/staff_statistics_role_controller'
import { useGender } from './controllers/gender_controller'
import { useStaff } from './controllers/staff_controller'
import { useDepartment } from './controllers/department_controller'
import { useDepartmentDepth } from './controllers/department_depth_controller'
import DepartmentRoleForm from './components/DepartmentRole';
import RoleDepartment from './components/role_department';
import { createContext } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BindLineId from '../login/BindLineId';
import { PropertyJson } from './DepartmentRoleManagement';
import { useCRUDController } from "../ui/classify_structure/CRUDController";
import { PermissionListModal } from '../permission_management/permission_list';
import throttle from 'lodash/throttle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';


const LanguageContext = createContext(null)
const Staff = ({
    keyPrefix = "organization_structure.staff",
    onSelect = () => { },
    toolBarRender = (tools) => ([...tools]),
    staff_id = null,
    show_tab_bar = true,
    show_chart = false,
    show_header_title = true,
    show_tool_bar = true,
    customFormItems = () => { }, //上層可加入自定義的form item 
    staffApi = "/organization_structure/api/staff", //staff 的api 名稱
    departmentApi = '/organization_structure/api/department',//department 的api 名稱
    customColumns = [], //列表編輯模式的顯示columns
    defaultSelectedKeys = [],
    defaultSelectedInfo = [],
    readonly = false,
    departmentMode = "department",
    RoleDepartmentMode = "role"
}) => {
    const [tableLoading, setTableLoading] = useState(false);
    const [form] = Form.useForm()
    const actionRef = useRef(null)
    const currentUserId = useRef(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedKeys)
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedInfo)
    const [extra_columns, set_extra_columns] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [total, set_total] = useState(1);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [permissionModalOpen, setPermissionModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState("get")
    const [roleOption, setRoleOption] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [selectDepartmentId, setSelectDepartmentId] = useState();
    const [selectRoleId, setSelectRoleId] = useState();

    const [importData, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false)

    const tabDepartmentId = useRef(undefined)
    const departmentId = useRef()
    const roleId = useRef()
    const defaultColumns = [
        {
            title: '編號(系統帳號)',
            key: 'staff_serial_name',
            dataIndex: 'staff_serial_name',
            align: 'center',
        },
        ...(departmentMode === "department" ? [{
            title: '讀者類型 - 職稱',
            key: 'user_department_role_data',
            dataIndex: 'user_department_role_data',
            align: 'left',
            render: (text, record, index) => (
                <Row>
                    {record.user_department_role_data && record.user_department_role_data.map((item) => (
                        <Col span={24}><Tag color="geekblue">
                            {
                                item?.department_name_language_data !== undefined
                                    ? (item?.role_name_language_data !== undefined
                                        ? (item?.department_name_language_data[0]?.language_culture_value + ' - ' + item?.role_name_language_data[0]?.language_culture_value)
                                        : item?.department_name_language_data[0]?.language_culture_value)
                                    : ''
                            }
                        </Tag></Col>
                    ))}
                </Row>
            )
        }] : []),
        ...(departmentMode === "structure" ? [{
            title: '系統角色',
            key: 'user_department_role_data',
            dataIndex: 'user_department_role_data',
            align: 'left',
            render: (text, record, index) => (
                <Row>
                    {record.user_department_role_data && record.user_department_role_data.map((item) => (<>
                        <Col>
                            <Tag color="geekblue">
                                {
                                    item?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                }
                                {item?.user_role_department_data && <>
                                    －
                                    {item?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                </>}
                            </Tag>
                        </Col>
                        <Col>
                            <Row>
                            </Row>
                        </Col>
                    </>))}
                </Row>
            )
        }] : []),
        {
            title: '姓名',
            key: 'staff_name',
            dataIndex: 'staff_name',
            align: 'center',
        },
        {
            title: '英文名',
            key: 'staff_english_name',
            dataIndex: 'staff_english_name',
            align: 'center',
        },
        {
            title: '性別',
            key: 'gender_name',
            dataIndex: 'gender_name',
            align: 'center',
        },

        {
            title: '電話',
            key: 'staff_phone',
            dataIndex: 'staff_phone',
            align: 'left',
        },
        {
            title: 'Email',
            key: 'email',
            dataIndex: 'email',
            align: 'left',
            render: (text) => (
                <Row>
                    <ExpandableText text={text} maxLines={1} />
                </Row>
            )
        },

        {
            title: '地址',
            key: 'address',
            dataIndex: 'address',
            align: 'left',
        },
        {
            title: '更多資訊',
            key: 'property_json',
            dataIndex: 'property_json',
            align: 'center',
            render: (text) => <>
                <Row>
                    {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
                </Row>
            </>
        },
        ...customColumns,
        {
            title: '建立人',
            key: 'create_user_name',
            dataIndex: 'create_user_name',
            align: 'center',
        },
        {
            title: '建立時間',
            key: 'create_time',
            dataIndex: 'create_time',
            align: 'center',
        },
        {
            title: '最後編輯人',
            key: 'last_edit_user_name',
            dataIndex: 'last_edit_user_name',
            align: 'center',
        },
        {
            title: '最後編輯時間',
            key: 'last_edit_time',
            dataIndex: 'last_edit_time',
            align: 'center',
        },
    ]
    const [default_column, set_default_column] = useState(defaultColumns);

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.staff_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.staff_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.staff_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.staff_id)
                selectRow = selectRow.filter(row => row.staff_id !== record.staff_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
                return
            }
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            else if (axiosMode === "import") {
                message.success("匯入成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "import") {
                message.error("匯入失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const personalInformationController = useCRUDController({ onBefore, onFinish, apiRoute: staffApi });
    const departmentController = useCRUDController({ onBefore, onFinish, apiRoute: departmentApi });
    const departmentOptionController = useCRUDController({ onBefore, onFinish, apiRoute: departmentApi });
    const roleController = useCRUDController({ onBefore, onFinish, apiRoute: "/organization_structure/api/role" });
    const resetPasswordController = useCRUDController({ onBefore, onFinish, apiRoute: "/organization_structure/api/user/reset_password" });

    useEffect(() => {
        roleController.getData({
            department_id_arr: departmentId.current
        })
    }, [])

    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [selectDepartmentId, selectRoleId])

    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        departmentRoleDataResult = departmentRoleDataTemp.map((item, index) => {
            let departmentId = undefined
            let roleId = undefined
            departmentOptionController.ResponseData.map((departmentDataItem, i) => {
                if (String(departmentDataItem.classify_structure_type_id) === String(item.department_classify_structure_type_id)) {
                    departmentId = departmentDataItem.department_id
                }
            })
            roleController.ResponseData.map((roleDataItem, ii) => {
                if (String(roleDataItem.classify_structure_type_id) === String(item.role_classify_structure_type_id)) {
                    roleId = roleDataItem.role_id
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId,
                    ...(item?.user_role_department_data ? {
                        user_role_department_data: changeDepartmentRole(item?.user_role_department_data)
                    } : {})
                }
            )
        })
        return departmentRoleDataResult;
    }

    const onFormFinish = () => {
        const values = form.getFieldsValue()
        let departmentRoleData = []
        if (values.user_department_role_data) {
            departmentRoleData = changeDepartmentRole(values.user_department_role_data)
        }

        let datas = [{
            ...values,
            "name": values?.staff_name,
            "user_language_data": departmentRoleData
        }]
        if (axiosMode === "post") {
            personalInformationController.postData(datas)
        } else if (axiosMode === "patch") {
            personalInformationController.patchData(datas)
        }
    }

    const changeData = (record) => {
        let data_tmp = importData.filter(item => item.index != record.index);
        setImportData(data_tmp);
    }

    const {
        StaffStatisticsGenderData,
        getStaffStatisticsGenderData
    } = useStaffStatisticsGender({})

    const {
        StaffStatisticsDepartmentData,
        getStaffStatisticsDepartmentData
    } = useStaffStatisticsDepartment({})

    const {
        StaffStatisticsRoleData,
        getStaffStatisticsRoleData
    } = useStaffStatisticsRole({})

    const {
        DepartmentData,
        getDepartmentData: getDepartmentDatas
    } = useDepartment({})

    const {
        DepartmentDepthData,
        getDepartmentDepthData
    } = useDepartmentDepth({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: ({ values }) => {
            let columns = [];
            values?.forEach(departmentDepth => {
                Object.entries(departmentDepth?.property_json)?.forEach(([property_json_key, property_json_value]) => {
                    columns.push({
                        title: property_json_key,
                        key: property_json_key,
                        dataIndex: property_json_key,
                        render: (text, record) => <>
                            {/* 拿個人部門 */}
                            {record?.user_department_role_data?.map(item => <>
                                {/* 篩選層級 */}
                                {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                    {/* 篩選屬性 */}
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItem?.property_json?.[property_json_key]}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    })
                })
                columns.push({
                    title: departmentDepth?.depth_name,
                    key: departmentDepth?.depth_name,
                    dataIndex: departmentDepth?.depth_name,
                    render: (text, record) => <>
                        {/* 拿個人部門 */}
                        {record?.user_department_role_data?.map(item => <>
                            {/* 篩選層級 */}
                            {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItemItem?.language_culture_value}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>)}
                    </>
                })
                // })
                // columns.push({
                //     title: departmentDepth?.depth_name,
                //     key: departmentDepth?.depth_name,
                //     dataIndex: departmentDepth?.depth_name,
                // })
            })
            set_default_column([
                ...columns,
                ...defaultColumns
            ])
            setLoading(false)
        }
    })

    const rowSelectionConfig = useMemo(() => ({
        type: 'checkbox',
        selectedRowKeys,
        setSelectedRowKeys,
        selectedRowsInfo,
        setSelectedRowsInfo,
        ...rowSelection,
    }), [selectedRowKeys, selectedRowsInfo, rowSelection]);

    const throttledRequest = throttle(async (params, sort, filter) => {
        let newParams = {
        };
        let order = setOrders(sort)
        newParams = {
            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
            ...newParams,
            order,
            size: params.pageSize,
            cur_page: params.current,
            custom_filter_value: params.keyword ?? "",
            custom_filter_key: custom_filter_key,
            department_id_arr: departmentId.current || (tabDepartmentId.current ? `{${tabDepartmentId.current}}` : undefined),
            role_id_arr: roleId.current,
        };
        newParams = setParamsFilter({
            ...newParams,
        });
        setPageSize(params?.pageSize ?? 20)

        return personalInformationController.getData({
            ...newParams
        })
    }, 300); // 每 300ms 最多執行一次


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns: default_column.concat(extra_columns || [])
    })


    const changeFormData = (data) => {
        let resultData = []
        resultData = data.map((item, index) => {
            let departmentRoleData = []
            if (item.user_department_role_data) {
                departmentRoleData = changeDepartmentRole(item.user_department_role_data)
            }
            return {
                ...item,
                "serial_name": item?.staff_serial_name,
                "name": item?.staff_name,
                "user_language_data": departmentRoleData
            }
        })
        return resultData
    }
    useEffect(() => {
        checkAll()
        // personalInformationController.getData()
        getStaffStatisticsGenderData()
        getStaffStatisticsDepartmentData()
        getStaffStatisticsRoleData()
        departmentController.getData({ classify_structure_type_id: 0, classify_structure_id: 9 })
        departmentOptionController.getData()
    }, [])

    useEffect(() => {
        onSelect(selectedRowsInfo, selectedRowKeys)
    }, [selectedRowsInfo])
    return (<>
        <LanguageContext.Provider vlaue={keyPrefix}>
        </LanguageContext.Provider>
        {show_tab_bar ?
            <Row>
                <Col>
                    <Tabs
                        items={[
                            {
                                key: undefined,
                                tab: '全部'
                            },
                            ...DepartmentData.map(item =>
                            (
                                {
                                    key: item.department_id,
                                    tab: item.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title
                                }
                            )
                            )]}
                        onChange={(departmentId) => {
                            tabDepartmentId.current = departmentId
                            if (departmentId === undefined) {
                                getDepartmentDepthData({ department_id: 0 })
                            } else {
                                getDepartmentDepthData({ department_id: departmentId })
                            }
                        }}
                    />
                </Col>
            </Row>
            : <></>}
        {show_chart ?
            <Row>
                <Col span={24}>
                    <BasicDataStats></BasicDataStats>
                </Col>
            </Row>
            : <></>}
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <WhiteBox>
                    {loading && <Skeleton />}
                    {!loading && <>
                        <PermissionListModal propsOpen={permissionModalOpen} propsSetOpen={setPermissionModalOpen} id={currentUserId.current} prefix={'user'} apiRoute={'/organization_structure/api/staff_diverge'} />

                        <ProTableOt
                            actionRef={actionRef}
                            columns={default_column}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'staff_id'}
                            request={async (params = {}, sort, filter) =>
                                throttledRequest(params, sort, filter)
                            }
                            propsPost={!readonly && true}
                            propsPatch={!readonly && true}
                            propsDelete={!readonly && true}
                            extraActionRender={(record) => <>
                                <Col span={24}>
                                    <Row gutter={[8, 8]}>
                                        <Col>
                                            <Popconfirm
                                                title="重設密碼"
                                                description="確定重設密碼嗎？"
                                                onConfirm={() => resetPasswordController.patchData([{ 'user_id': record?.user_id }])}
                                                onCancel={() => { }}
                                            >
                                                <Button
                                                    type="primary"
                                                    style={{
                                                        backgroundColor: "#7FA1C3",
                                                    }}
                                                >
                                                    重設密碼
                                                </Button>
                                            </Popconfirm>
                                        </Col>
                                        <Col>
                                            <Button
                                                style={{
                                                    color: '#000000',
                                                    backgroundColor: "#E2DAD6",
                                                }}
                                                onClick={() => {
                                                    currentUserId.current = record?.user_id
                                                    setPermissionModalOpen(true)
                                                }}>
                                                統一權限設定
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </>}
                            toolBarRender={() => toolBarRender([
                                !readonly &&
                                <Button className='example' style={{ background: '#1565C0', color: '#ffffff' }} onClick={e => personalInformationController.exportData({ 'staff_id_arr': selectedRowKeys })}>
                                    匯出資料 <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                                </Button>,
                                !readonly &&
                                <ImportButton
                                    handleDownload={e => personalInformationController.downloadData()}
                                    handleImport={e => {
                                        e['columns'] = default_column.concat(extra_columns || []); personalInformationController.importData(e)
                                        set_upload_modal(false)
                                        set_import_modal(false)
                                    }}
                                    set_upload_modal={set_upload_modal}
                                    upload_modal={upload_modal}
                                    importData={importData}
                                    setImportData={setImportData}
                                    import_modal={import_modal}
                                    set_import_modal={set_import_modal}
                                    handleReserve={e => personalInformationController.patchData(e)}
                                    handleOver={e => personalInformationController.overData(e)}
                                    columns={[...default_column.concat(extra_columns || []), {
                                        title: '保留/覆蓋',
                                        align: 'center',
                                        render: (text, record, index) => {
                                            if (record.type == 'name') {
                                                return (
                                                    <>
                                                        <Button type="text" style={{ color: '#4CAF50' }} onClick={e => { changeData(record) }}>保留</Button>
                                                    </>)
                                            } else if (record.type == 'both') {
                                                return (
                                                    <>
                                                        <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { personalInformationController.patchData([record]); changeData(record) }}>覆蓋</Button>
                                                    </>
                                                )
                                            }
                                        }
                                    }]}
                                />,
                            ])}
                            rowSelection={rowSelectionConfig}

                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={true}
                            scroll={{ x: 'max-content' }}

                            propsUseData={() => {
                                return {
                                    postData: (data) => {
                                        personalInformationController.postData(changeFormData(data))
                                    },
                                    patchData: (data) => {
                                        personalInformationController.patchData(changeFormData(data))
                                    },
                                    deleteData: personalInformationController.deleteData,
                                }
                            }}
                            PropsPatchForm={<StaffForm
                                customFormItems={customFormItems}
                                axiosMode={axiosMode}
                                // onFormFinish={onFormFinish}
                                departmentMode={departmentMode}
                                edit={false}
                            />}
                            modalOpen={modalOpen}
                            setModalOpen={setModalOpen}
                            propsWidth={1000}
                            manageColumnsButton={!readonly && true}
                            pageSize={pageSize}
                        />
                    </>}
                </WhiteBox>
            </Col>
        </Row>
    </>)
}
export default Staff;

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}

const WhiteBox = styled.div`
                background-color: #fff;
                padding: 1em;
                width: 100%;
                `

const StaffForm = ({
    mode = "modal",
    keyPrefix = "organization_structure.staff",
    /* 欄位標籤前置位置 */
    propsForm,
    /* 是否為parent物件控制form */
    formReloadCount = 0,
    /* 強制刷新的變數 */
    onFormFinish = () => { },
    /* 送出表單後的事件 */
    field,
    staff_id,
    defaultValue,
    customFormItems = () => { },
    propsOnValuesChange = () => { },
    departmentMode = "department",
    ...props
}) => {
    const [columnRequires, setColumnRequires] = useState([])
    const [chagePassword, setChagePassword] = useState(false)
    const [count, setCount] = useState(0);
    const [form_] = Form.useForm();
    const form = propsForm || form_
    /* 表單物件宣告 */
    const keyPrefix_ = useContext(LanguageContext);
    /* 欄位標籤前置位置 */
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    /* 初始化語言呈現的位置，依照預設標籤位置、也可以引入標籤位置 */
    const setFormValuesOtherThings = (formValues) => {
        /* 設定form的數值 */
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        /* 重新調整form的連動數值邏輯區域 */
        if (propsForm) {
            /* fom由paret進行控制 */
            propsForm.setFieldsValue(newFormValues)
            /* 設定parent form使用者輸入內容的值 */
        }
        else {
            form.setFieldsValue(newFormValues)
            /* 設定使用者輸入內容的值 */
        }
    }
    const setDataInitialization = () => {
        /* 設定初始化時要執行的業務邏輯 */
        getGenderData()
    }
    const onFinish = (values) => {
        /* form submit之後觸發事件 */
        onFormFinish({
            ...values,
        })
        /* 呼叫上層function */

    }
    const onValuesChange = () => {
        /* 取得被改變的欄位 */
        let formValues = null
        /* 現有使用者輸入內容初始化 */
        if (propsForm) {
            /* 判斷form的物件來源 */
            formValues = propsForm.getFieldsValue()
            /* 現在取得使用者輸入內容 */
        }
        else {
            formValues = form.getFieldsValue()
            /* 現在取得使用者輸入內容 */
        }
        propsOnValuesChange(formValues)
    }

    const { GenderData, getGenderData } = useGender({})

    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])

    useEffect(() => {
        setTimeout(() => {
            setCount(pre => pre + 1)
        }, 1000)
    }, [])


    let DepartmentRole = DepartmentRoleForm
    if (departmentMode === "structure") {
        DepartmentRole = RoleDepartment
    }
    return <>
        <Form
            form={form}
            name="question"
            initialValues={{ remember: true }}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            // autoComplete="off"
            autoComplete="new-password"
        >
            {mode !== "information" && <>
                <Row gutter={[8, 8]}>
                    <Col xxl={mode === "modal" ? 24 : 12}
                        xl={mode === "modal" ? 24 : 12}
                        lg={mode === "modal" ? 24 : 12}
                        md={24}
                        sm={24}
                        xs={24}>
                        <Form.Item
                            name="staff_id"
                            hidden
                        >
                        </Form.Item>
                        <Form.Item
                            name="user_id"
                            hidden
                        >
                        </Form.Item>
                        <Form.Item
                            name="serial_name"
                            hidden
                        >
                        </Form.Item>
                        <Form.Item
                            label={"編號(系統帳號)"}
                            name="staff_serial_name"
                            rules={[
                                {
                                    required: columnRequires.includes("staff_serial_name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            {/* <Tag bordered={false} color="processing"> */}

                            <Input bordered={false} disabled={props.edit}>
                            </Input>
                            {/* </Tag> */}
                        </Form.Item>
                        <Form.Item
                            label={"姓名"}
                            name="staff_name"
                            rules={[
                                {
                                    required: columnRequires.includes("staff_name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input>
                            </Input>
                        </Form.Item>
                        <Form.Item
                            label={"英文姓名"}
                            name="staff_english_name"
                            rules={[
                                {
                                    required: columnRequires.includes("staff_english_name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input>
                            </Input>
                        </Form.Item>
                        <Form.Item
                            label={"性別"}
                            name="gender_id"
                            rules={[
                                {
                                    required: columnRequires.includes("gender_id"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Select
                                options={GenderData.map((value) => {
                                    return {
                                        label: value.gender_name,
                                        value: String(value.gender_id)
                                    }
                                })}
                            >
                            </Select>
                        </Form.Item>
                        {/* {!props.edit && */}
                        {props.edit &&
                            <Form.List
                                key={count}
                                label={"角色"}
                                name={"user_department_role_data"}
                                rules={[
                                    {
                                        required: columnRequires.includes("department_role"),
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                {(fields, { add, remove }) => (
                                    <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                                        <Col span={16} >
                                            <Button
                                                style={{ width: '100%' }}
                                                onClick={
                                                    () => {
                                                        add();
                                                    }
                                                }>{departmentMode === "structure" ? '新增角色' : '新增部門'}</Button>
                                        </Col>
                                        {fields?.map((field, key) => (<>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={`讀者類型職位 - ${key + 1}`}
                                                    // label={`${departmentMode === "structure" ? '系統角色' : '分配部門'} - ${key + 1}`}
                                                    name=""
                                                    rules={[
                                                        {
                                                            required: columnRequires.includes(""),
                                                            message: `此為必填項目`
                                                        }
                                                    ]}
                                                >
                                                    <DepartmentRole
                                                        // key={field.id}
                                                        field={field}
                                                        propsForm={form}
                                                        remove={remove}
                                                        onDepartmentRoleChange={() => {
                                                            form.getFieldsValue()
                                                            onValuesChange()
                                                        }}
                                                        defaultDepartment={form.getFieldValue([field.name, "department_classify_structure_type_id"])}
                                                        defaultRole={form.getFieldValue([field.name, "role_classify_structure_type_id"])}
                                                    ></DepartmentRole>
                                                </Form.Item>
                                            </Col>
                                        </>))}
                                    </Row>
                                )}
                            </Form.List>
                        }
                        {customFormItems()}
                        <Form.Item
                            label={"電話"}
                            name="staff_phone"
                        >
                            <Input autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"Email"}
                            name="email"
                            rules={[
                                {
                                    required: columnRequires.includes("email"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"Line ID"}
                            name="custom_line_id"
                            rules={[
                                {
                                    required: columnRequires.includes("custom_line_id"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label={"地址"}
                            name="address"
                            rules={[
                                {
                                    required: columnRequires.includes("address"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input autocomplete="new-password" />
                        </Form.Item>
                    </Col>
                    <Col xxl={mode === "modal" ? 0 : 12}
                        xl={mode === "modal" ? 0 : 12}
                        lg={mode === "modal" ? 0 : 12}
                        md={mode === "modal" ? 0 : 24}
                        sm={mode === "modal" ? 0 : 24}
                        xs={mode === "modal" ? 0 : 24}
                    >
                        {props.edit && <>
                            <Form.Item
                                label={"Line 綁定"}
                                name={"Line 綁定"}
                            >
                                <BindLineId />
                            </Form.Item>
                            <Form.Item
                                label={"修改密碼"}
                                name="status"
                            >
                                <Switch onChange={(res) => setChagePassword(res)}
                                    checkedChildren={"開啟"}
                                    unCheckedChildren={"關閉"} />
                            </Form.Item>
                        </>}
                        {chagePassword && props.edit && <>
                            <Form.Item
                                label={"舊密碼"}
                                name="old_password"
                                rules={[
                                    {
                                        required: true,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                            <Form.Item
                                label={"修改密碼"}
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                            <Form.Item
                                label={"再次輸入"}
                                name="password1"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: '請確認新密碼',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('兩次密碼不相同'));
                                        },
                                    }),
                                ]}

                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                        </>}
                    </Col>
                </Row>
                {mode === "modal" && <>
                    {props.edit && <>
                        <Form.Item
                            label={"Line 綁定"}
                            name={"Line 綁定"}
                        >
                            <BindLineId />
                        </Form.Item>
                        <Form.Item
                            label={"修改密碼"}
                            name="status"
                        >
                            <Switch onChange={(res) => setChagePassword(res)}
                                checkedChildren={"開啟"}
                                unCheckedChildren={"關閉"}
                            />
                        </Form.Item>
                    </>}
                    {chagePassword && props.edit && <>
                        <Form.Item
                            label={"舊密碼"}
                            name="old_password"
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"修改密碼"}
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"再次輸入"}
                            name="password1"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: '請確認新密碼',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('兩次密碼不相同'));
                                    },
                                }),
                            ]}

                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                    </>}
                    <Form.Item
                        name={"property_json"}
                    >
                        <PropertyJson />
                    </Form.Item>
                </>}
            </>}
            {mode === "information" && <>
                <Form.Item
                    name={[field?.name ?? '', 'staff_id']}
                >
                    <StaffInformation
                        staff_id={staff_id}
                    />
                </Form.Item>
            </>}
        </Form>
    </>
}
export { StaffForm }

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
const BasicDataStats = () => {
    // 模擬統計數據
    const totalUsers = 1000;
    const lineBoundUsers = 300;
    const qrCodeBoundUsers = 450;
    const unboundLineUsers = totalUsers - lineBoundUsers;
    const unboundQRCodeUsers = totalUsers - qrCodeBoundUsers;

    // Line 綁定與未綁定人數
    const lineChartData = {
        labels: ['已綁定', '未綁定'],
        datasets: [{
            label: 'Line 綁定狀況',
            data: [lineBoundUsers, unboundLineUsers],
            backgroundColor: ['rgba(54, 162, 235, 0.6)', 'rgba(255, 99, 132, 0.6)'],
            borderColor: ['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)'],
            borderWidth: 1,
        }]
    };

    // QRCode 綁定與未綁定人數
    const qrCodeChartData = {
        labels: ['已綁定', '未綁定'],
        datasets: [{
            label: 'QRCode 綁定狀況',
            data: [qrCodeBoundUsers, unboundQRCodeUsers],
            backgroundColor: ['rgba(75, 192, 192, 0.6)', 'rgba(255, 159, 64, 0.6)'],
            borderColor: ['rgba(75, 192, 192, 1)', 'rgba(255, 159, 64, 1)'],
            borderWidth: 1,
        }]
    };

    // 總人數的條形圖
    const totalUsersChartData = {
        labels: ['總人數'],
        datasets: [{
            label: '基本資料維護總人數',
            data: [totalUsers],
            backgroundColor: 'rgba(153, 102, 255, 0.6)',
            borderColor: 'rgba(153, 102, 255, 1)',
            borderWidth: 1,
        }]
    };

    return (
        <Row>
            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>基本資料維護總人數</h3>
                <Bar data={totalUsersChartData} />
            </Col>
            {/* Line 綁定人數 */}

            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>Line 綁定人數</h3>
                <Pie data={lineChartData} />
            </Col>
            {/* QRCode 綁定人數 */}
            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>QRCode 綁定人數</h3>
                <Pie data={qrCodeChartData} />
            </Col>
        </Row>
    );
}

const StaffInformation = ({
    staff_id,
    value,
    onChange,
    onValuesChange
}) => {
    const { StaffData, getStaffData } = useStaff({ onBefore: () => { }, onFinish: () => { } })
    useEffect(() => {
        getStaffData({
            staff_id: staff_id ?? value
        })
    }, [value, staff_id])
    const staff = StaffData?.find(_ => true) || {}
    return <>
        <FormContainer>
            <FormTitle>現在登入人員資訊</FormTitle>
            <FormField>
                <Label>姓名</Label>
                <Input type="text" value={staff?.staff_name} disabled />
            </FormField>
            <FormField>
                <Label>電子郵件</Label>
                <Input type="email" value={staff?.email} disabled />
            </FormField>
            <FormField>
                <Label>人員編號</Label>
                <Input type="text" value={staff?.serial_name} disabled />
            </FormField>
        </FormContainer>
    </>
}

// Styled Components
const FormContainer = styled.div`
                display: flex;
                flex-direction: column;
                max-width: 400px;
                margin: 50px auto;
                padding: 20px;
                border: 1px solid #ccc;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                `;

const FormTitle = styled.h2`
                margin-bottom: 20px;
                text-align: center;
                color: #333;
                `;

const FormField = styled.div`
                margin-bottom: 15px;
                `;

const Label = styled.label`
                display: block;
                margin-bottom: 5px;
                font-weight: bold;
                color: #555;
                `;

